import { render, staticRenderFns } from "./TurnServer.vue?vue&type=template&id=f2e0410a&scoped=true&"
import script from "./TurnServer.vue?vue&type=script&lang=js&"
export * from "./TurnServer.vue?vue&type=script&lang=js&"
import style0 from "./TurnServer.vue?vue&type=style&index=0&id=f2e0410a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e0410a",
  null
  
)

export default component.exports